import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 4v16h6v-2H5V8h14v10h-4v2h6V4H3zm9 6l-4 4h3v6h2v-6h3l-4-4z"
}), 'OpenInBrowserSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/OpenInBrowserSharp.js
// module id = 5144
// module chunks = 2